export function setupAuthGuard(router) {
  router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('auth_token')
    if (to.meta.requiresAuth && !token) {
      next({ name: 'login' })
    } 
    else if (to.meta.requiresGuest && token) {
      next({ name: 'home' })
    } 
    else {
      next()
    }
  })
}